import { render, staticRenderFns } from "./IScaleImage.vue?vue&type=template&id=832f96d0&scoped=true&"
import script from "./IScaleImage.vue?vue&type=script&lang=js&"
export * from "./IScaleImage.vue?vue&type=script&lang=js&"
import style0 from "./IScaleImage.vue?vue&type=style&index=0&id=832f96d0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832f96d0",
  null
  
)

export default component.exports